<template>
  <header class="h5-header">
      <a href="" class="h5Header-logo">
          <h1 class="h5Header-title">魔泊云</h1>
      </a>
      <div class="h5Header-right">
         <button class="h5Header-menu" data-show="false" @click="reverseShowState" ></button>
           <ul class="h5Header-menuLists" role="menubar" >
             <li class="h5Header-menuLists__item" tabindex="-1" aria-checked="false">
               <router-link  to="/news" class="h5Header-menuLists__item_link">最新资讯</router-link>
             </li>
           </ul>
      </div>
  </header>
</template>

<script>
export default {
    name: 'home-header',
    methods: {
        reverseShowState(event){
            let btn = event.target;
            console.log(btn.dataset.show)
            btn.dataset.show = btn.dataset.show === 'false'?'true':'false'
        }
    }
}
</script>

<style>
.h5-header {
    position: fixed;
    z-index: 10;
    display:flex;
    width: 100vw;
    height: 8vw;
    background: #04375D;
    align-items: center;
}
.h5Header-logo {
    width: 15.6vw;
    height: 47.76%;
    background:url(../../assets/images/logo.png) center/contain no-repeat;
}
.h5Header-title {
    font-size: 0;
}
.h5Header-right {
    position: relative;
    display: flex;
    height: 100%;
    align-items: center;
    padding-right: 3.466667%;
    margin-left: auto;
    display: none;
}
.h5Header-menu {
    width: 4.133333333333334vw;
    padding: 0.8vw 0;
    border-top: 0.4vw solid #00EBF6;
    border-bottom: 0.4vw solid #00EBF6;
    text-align: left;
    background: none;
    cursor: pointer;
}
.h5Header-menu:focus + .h5Header-menuLists,.h5Header-menu[data-show="true"] + .h5Header-menuLists{
    display: block;
}
.h5Header-menu:focus-within + .h5Header-menuLists {
    display: block;
}
.h5Header-menu:before {
    display: block;
    height: 0.4vw;
    border-radius: 0.4vw;
    background: #00EBF6;
    content: '';
}
.h5Header-menu[data-show="false"] + .h5Header-menuLists{
    display: none;
}
.h5Header-menuLists {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 99;
    display: none;
}
.h5Header-menuLists__item {
    min-width: 26.666666666666668vw;
    padding: 0 1em;
    text-align: left;
    background: #04375D;
    box-sizing: border-box;
}
.h5Header-menuLists__item_link {
    font-size: 2.6666666666666665vw;
    line-height: 5.333333333333333vw;
    white-space: nowrap;
    color: #fff;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/home-header.vue